import { ajaxController } from './controller/AjaxController'

export interface ShiftBandDto {
  shift: string
  shiftNumber: number
  startTime: string
  durationHours: number
}

export interface ShiftBandsResponse {
  timeZone: string
  shiftBands: ShiftBandDto[]
}

class ConfigAjax {
  async getShiftBands() {
    return ajaxController.get<ShiftBandsResponse>('/Config/shift-bands', {})
  }
}

export const configAjax = new ConfigAjax()
